import {noten} from "../data/noten";

class Calculations {
  constructor(schueler, klausur) {
    const afb1PointsAnteil = (schueler.afb1Points * klausur.prozentAfb1) / 100;
    const afb2PointsAnteil = (schueler.afb2Points * klausur.prozentAfb2) / 100;
    const afb3PointsAnteil = (schueler.afb3Points * klausur.prozentAfb3) / 100;

    // Common: Anteil der Abschnitte AFB 1 bis 3
    const sumAfb1Bis3Anteil = afb1PointsAnteil + afb2PointsAnteil + afb3PointsAnteil;
    const sumAfb1Bis3AnteilRounded = Math.round(sumAfb1Bis3Anteil);
    const prozentAufgabenbearbeitung = 100 - klausur.sprachverwendung;
    const aufgabenBearbeitungGewichtung = (sumAfb1Bis3AnteilRounded * prozentAufgabenbearbeitung) / 100;

    //Sprachverwendung (Berlin)
    const sprachePointsAnteil = (schueler.sprachePoints * klausur.sprachverwendung) / 100;

    //Gesamtpunktzahl für Berlin
    const erreichteGesamtpunktzahl = aufgabenBearbeitungGewichtung + sprachePointsAnteil;
    const resultPointsRounded = Math.round(erreichteGesamtpunktzahl);

    // Brandenburg
    const correct = parseInt(schueler.spracheKorrektPoints);
    const ausdruck = parseInt(schueler.spracheAusdruckPoints);
    const lesen = parseInt(schueler.spracheLesenPoints);
    const sum = correct + ausdruck + lesen;
    const roundedAfb = Math.round(sumAfb1Bis3Anteil);
    const anzahlunter7punkte = [correct, ausdruck, lesen].filter(i => i < 7).length;
    const anzahlunter4punkte = [correct, ausdruck, lesen].filter(i => i < 4).length;
    const abzug = anzahlunter4punkte >= 2 ? -2 : anzahlunter7punkte >= 2 && sum <= 18 ? -1 : 0;
    const gesamtpunkte = roundedAfb + abzug;
    const gesamtnote = noten[`0${gesamtpunkte}`.slice(-2)];

    // Ausgabe
    const common = {sumAfb1Bis3Anteil, sumAfb1Bis3AnteilRounded};
    this.results = {
      Berlin: {
        ...common,
        prozentSprachverwendung: klausur.sprachverwendung,
        sprachePointsAnteil,
        prozentAufgabenbearbeitung,
        aufgabenBearbeitungGewichtung,
        erreichteGesamtpunktzahl,
        resultPointsRounded,
        gesamtnote: noten[`0${resultPointsRounded}`.slice(-2)]
      },
      Brandenburg: {...common, abzug, roundedAfb, gesamtpunkte, gesamtnote}
    };
  }
}
export default Calculations;
